module.exports = {
	siteName: 'login',
	site: {
		mancity: {
			appI18nConfig: {
				defaultLocale: 'en',
				supportedLocales: ['en', 'it'],
			},
		},
		palermo: {
			appI18nConfig: {
				defaultLocale: 'it',
				supportedLocales: ['en', 'it', 'fr'],
			},
		},
	},
};
